const routingInfoDetails = [
  {
    name: 'Ally Bank',
    routingNumbers: ['124003116'],
    code: 'Ally'
  },
  {
    name: 'Bank of America',
    routingNumbers: [
      '011000138',
      '011200365',
      '011400495',
      '011500010',
      '011900254',
      '021000322',
      '021200339',
      '031202084',
      '051000017',
      '051000018',
      '052001633',
      '053000196',
      '053904483',
      '054001204',
      '061000052',
      '063000047',
      '063100277',
      '064000020',
      '071000505',
      '071103619',
      '071214579',
      '072000805',
      '073000176',
      '081000032',
      '081000033',
      '081904808',
      '082000073',
      '101000035',
      '101100045',
      '103000017',
      '107000327',
      '111000025',
      '113000023',
      '121000358',
      '122101706',
      '122400724',
      '123103716',
      '125000024',
      '323070380'
    ],
    code: 'BOFA'
  },

  {
    name: 'BB&T',
    routingNumbers: [
      '031204710',
      '031309123',
      '042102267',
      '051404260',
      '051503394',
      '053101121',
      '053201607',
      '054001547',
      '055003308',
      '061113415',
      '062203984',
      '064208165',
      '083900680',
      '083974289',
      '111017694',
      '263191387'
    ],
    code: 'BBT'
  },
  {
    name: 'Capital One',
    routingNumbers: ['051405515', '056073502', '056073612'],
    code: 'CAPITAL'
  },
  {
    name: 'Charles Schwab',
    routingNumbers: ['121202211'],
    code: 'SCHWAB'
  },
  {
    name: 'Chase',
    routingNumbers: [
      '021000021',
      '021100361',
      '021202337',
      '022300173',
      '044000037',
      '051900366',
      '061092387',
      '065400137',
      '071000013',
      '072000326',
      '074000010',
      '075000019',
      '083000137',
      '102001017',
      '103000648',
      '111000614',
      '122100024',
      '123271978',
      '124001545',
      '267084131',
      '322271627',
      '325070760'
    ],
    code: 'CHS'
  },
  {
    name: 'Citibank',
    routingNumbers: [
      '021000089',
      '021001486',
      '021272655',
      '052002166',
      '113193532',
      '221172610',
      '254070116',
      '266086554',
      '271070801',
      '321171184',
      '322271724'
    ],
    code: 'CITI'
  },
  {
    name: 'Citizens Bank',
    routingNumbers: [
      '011401533',
      '011500120',
      '021313103',
      '031101143',
      '036076150',
      '211070175',
      '211170114',
      '241070417'
    ],
    code: 'CBK'
  },
  {
    name: 'Discover Bank',
    routingNumbers: ['031100649'],
    code: 'DISC'
  },
  {
    name: 'Fidelity',
    routingNumbers: ['101205681'],
    code: 'FID'
  },
  {
    name: 'Fifth Third Bank',
    routingNumbers: [
      '041002711',
      '041200050',
      '042000314',
      '042100230',
      '042101190',
      '042202196',
      '042207735',
      '043018868',
      '044002161',
      '053100737',
      '063103915',
      '063109935',
      '063113057',
      '064103833',
      '067091719',
      '071923909',
      '072400052',
      '072401404',
      '072405455',
      '074908594',
      '081019104',
      '083002342',
      '086300041',
      '263190812'
    ],
    code: '53B'
  },
  {
    name: 'Huntington National Bank',
    routingNumbers: [
      '041000153',
      '041200555',
      '041215016',
      '041215032',
      '042015422',
      '042100191',
      '042101459',
      '042107602',
      '042215060',
      '044000024',
      '044108641',
      '044115090',
      '044115126',
      '044172282',
      '051500520',
      '051903761',
      '057000697',
      '072400528',
      '072403473',
      '072410123',
      '074000078',
      '074905173',
      '075901998',
      '274070484'
    ],
    code: 'HNB'
  },
  {
    name: 'Navy Federal',
    routingNumbers: ['256074974'],
    code: 'NFCU'
  },
  {
    name: 'PNC',
    routingNumbers: [
      '031100089',
      '031207607',
      '041000124',
      '042000398',
      '043000096',
      '053100850',
      '054000030',
      '061192630',
      '071921891',
      '083000108',
      '267084199',
      '271971560'
    ],
    code: 'PNC'
  },
  {
    name: 'Regions',
    routingNumbers: [
      '051009296',
      '053012029',
      '053201814',
      '061101375',
      '062000019',
      '063104668',
      '064000017',
      '065305436',
      '065403626',
      '071122661',
      '073900438',
      '074014213',
      '081001387',
      '082000109',
      '083901744',
      '111900785'
    ],
    code: 'RGN'
  },
  {
    name: 'Suntrust',
    routingNumbers: ['061000104'],
    code: 'STB'
  },
  {
    name: 'TD Bank',
    routingNumbers: [
      '011103093',
      '011400071',
      '011600033',
      '021302567',
      '026013673',
      '031201360',
      '036001808',
      '053902197',
      '054001725',
      '067014822',
      '211274450',
      '211370545'
    ],
    code: 'TDB'
  },
  {
    name: 'US Bank',
    routingNumbers: [
      '041202582',
      '042000013',
      '042100175',
      '064000059',
      '071904779',
      '073000545',
      '074900783',
      '075000022',
      '081000210',
      '081202759',
      '082000549',
      '083900363',
      '091000022',
      '091215927',
      '091300023',
      '091408501',
      '092900383',
      '101000187',
      '101200453',
      '102000021',
      '102101645',
      '104000029',
      '107002312',
      '121122676',
      '121201694',
      '122105155',
      '122235821',
      '123000220',
      '123103729',
      '124302150',
      '125000105',
      '307070115'
    ],
    code: 'USB'
  },
  {
    name: 'USAA',
    routingNumbers: ['314074269'],
    code: 'USAA'
  },
  {
    name: 'Wells Fargo',
    routingNumbers: [
      '021101108',
      '021200025',
      '026012881',
      '031000503',
      '031100869',
      '041215537',
      '051400549',
      '053000219',
      '053207766',
      '054001220',
      '055003201',
      '061000227',
      '062000080',
      '062203751',
      '063107513',
      '064003768',
      '071101307',
      '073000228',
      '074900275',
      '075911988',
      '091000019',
      '091101455',
      '091300010',
      '091400046',
      '092905278',
      '101089292',
      '102000076',
      '102301092',
      '104000058',
      '107002192',
      '111900659',
      '112000066',
      '113105449',
      '121042882',
      '122105278',
      '123006800',
      '124002971',
      '124103799',
      '125008547',
      '125200057',
      '321270742'
    ],
    code: 'WFB'
  }
];
export default routingInfoDetails;
